export const getUploadErrorMessage = (err: any): string => {
  // Prefer a specific message from the backend (e.g. multer's German
  // "file too large" via the global error handler) when one is present.
  const backendMessage = err?.response?.data?.message;
  if (typeof backendMessage === "string" && backendMessage.trim()) {
    return backendMessage;
  }
  // No JSON body — e.g. nginx rejects an over-sized body with a 413 HTML page
  // before the request reaches Node. Fall back to a file-generic message.
  if (err?.response?.status === 413) {
    return "Die Datei ist zu groß. Bitte wählen Sie eine kleinere Datei.";
  }
  return "Etwas ist schief gelaufen...";
};
